<template>
  <Menubar />

  <Dialog :draggable="false" ref="notas" v-model:visible="visiblePDF" modal :header="title" :style="{ width: '70vw' }">
    <PdfView :pdf_url="aviso" />
    <template #footer>
      <Button style="background-color: gray" label="Cerrar" @click="visiblePDF = false" />
      <Button severity="danger" label="Continuar" @click="redirect('/registro_usuarios'); visiblePDF = false;" />
    </template>
  </Dialog>

  <Dialog :draggable="false" v-model:visible="visible" modal :header="notas" :style="{ width: '50vw' }">
    <div v-if="notas == 'Toma nota!!!'">
      <div :key="key" v-for="(item, key) of list_notes" class="flex">
        <strong>*</strong>
        <p class="ml-3"> {{ item }}</p>
      </div>
    </div>

    <div v-if="notas == 'Requisitos a presentar en su registro'">
      <ol>
        <strong :key="key" v-for="(item, key) of requisitos">
          <li class="mb-3">{{ item }}</li>
        </strong>
      </ol>
      <InlineMessage :pt="{
        icon: { class: 'hidden' },
      }" :style="{
  border: 'solid #3A9DC4',
  borderWidth: '0 0 0 6px',
  color: '#3186E2',
}" severity="info" class="border-primary w-full justify-content-start">
        <div class="flex align-items-center">
          <div class="ml-2 text-justify">
            <strong>todos los documentos deben presentarse en PDF y la fotografía en
              extensión .JPG</strong>
          </div>
        </div>
      </InlineMessage>
    </div>
  </Dialog>

  <div class="content mt-3 mb-3 xsw-11 md:w-5">
    <div class="text-center">
      <h2>
        {{
          type_call == "AES"
          ? "Aspirante a Estudiante"
          : type_call == "ADO"
            ? "Aspirante a Docente"
            : "Nuevas sedes"
        }}
      </h2>
      <Divider />
    </div>
    <Fieldset :legend="legend">
      <div :key="key" v-for="(item, key) of sections">
        <div v-if="item.tipo !== 'inlineMsg' && item.tipo !== 'listNotes'">
          <Divider />
          <div class="flex">
            <div class="w- text-center">
              <i class="mt-5 md:mt-0" :class="{
                'pi pi-file-pdf danger-icon': item.tipo == 'normal',
                'pi pi-calendar success-icon': item.tipo == 'calendar',
                'pi pi-send secondary-icon': item.tipo == 'noAction',
              }"></i>
            </div>
            <Divider layout="vertical" />
            <div class="w-full flex flex-column md:flex-row justify-content-between align-items-center">
              <strong>{{ item.desc }}
                <span v-if="item.tipo == 'calendar'">{{ call?.inicio }} / Fecha de cierre: {{ call?.fin }}</span></strong>
              <Button v-if="item.tipo != 'calendar' && item.tipo != 'noAction'" class="mt-2 md:mt-0" type="button" @click="
                viewDocument(
                  item.doc == 'convocatoria'
                    ? call?.convocatoria
                    : call?.manual
                )
                " label="Descargar" icon="pi pi-download" outlined />
            </div>
          </div>
        </div>
        <div v-if="item.tipo == 'inlineMsg' && type_call == 'AES'">
          <div class="flex mt-5">
            <div>
              <InlineMessage :pt="{
                icon: { class: 'hidden' },
              }" :style="{
  border: 'solid #3A9DC4',
  borderWidth: '0 0 0 6px',
  color: '#3186E2',
}" severity="info" class="border-primary w-full justify-content-start">
                <div class="flex align-items-center">
                  <div class="ml-2 text-justify">
                    <strong>{{ item.desc }}</strong>,
                    <Button @click="() => {
                      this.visible = true;
                      this.notas = 'Toma nota!!!';
                    }
                      " class="p-0" label="ver más" style="color: rgb(28, 27, 27)" link />
                  </div>
                </div>
              </InlineMessage>
            </div>
          </div>
        </div>
        <div v-if="item.tipo == 'listNotes'">
          <Divider />
          <div class="flex">
            <div class="w- text-center">
              <i class="pi pi-list" style="color: rgb(64, 65, 65); font-size: 2rem"></i>
            </div>
            <Divider layout="vertical" />
            <div class="w-full flex justify-content-between align-items-center">
              <strong>{{ item.desc }} </strong>
              <Button type="button" label="Ver" icon="pi pi-search" outlined @click="() => {
                this.visible = true;
                this.notas = 'Requisitos a presentar en su registro';
              }
                " />
            </div>
          </div>
        </div>
      </div>
      <Divider v-if="call?.status == 'vigente'" />
      <div v-if="call?.status == 'vigente'" class="flex">
        <div class="w- text-center">
          <i class="pi pi-users" style="color: rgb(64, 65, 65); font-size: 2rem"></i>
        </div>
        <Divider layout="vertical" />
        <div class="w-full flex justify-content-between align-items-center">
          <strong>Debes contar con tu usuario y contraseña para
            <Button @click="redirect('/login')" class="p-0" label="iniciar sesión" link />
            , para registrarte en la Convocatoria:
          </strong>
        </div>
      </div>
      <Divider v-if="call?.status == 'vigente'" />

      <div class="flex" v-if="call?.status == 'vigente'">
        <div class="w-full flex justify-content-center align-items-center">
          <Button @click="prepareRegister()" type="button" label="REGÍSTRATE A LA CONVOCATORIA" severity="danger"
            icon="pi pi-file-edit" />
        </div>
      </div>
    </Fieldset>
  </div>
</template>
<script>
import Menubar from "@/components/shared/Menubar.vue";
import * as calls from "@/services/getCalls.js";
import PdfView from "@/components/shared/PdfView.vue";

export default {
  props: {
    type_call: { type: String },
  },
  mounted() {
    let leyend;
    const calls = ["ASE", "AES", "ADO"];
    calls.includes(this.type_call) == false &&
      this.$router.push({
        path: "/convocatorias",
      });
    let _id = this.type_call == "AES" ? 5 : this.type_call == "ADO" ? 6 : 7;
    this.getDetail(_id);

    switch (this.type_call) {
      case "ADO":
        leyend = "de docentes";
        this.convocatoria = "/files/documents/convocatorias/ConvocatoriaAspirantesDocentes.pdf";
        this.manual = "/files/documents/convocatorias/ManualAspirantesDocentes.pdf";
        this.title = "Aviso docentes"
        this.aviso = "/files/documents/convocatorias/AvisoDocentes.pdf";
        this.requisitos =  [
          " Título universitario de preferencia maestría, doctorado y especialidades y en el caso de nivel licenciatura contar con amplia experiencia profesional mayor a 5 años",
          "Cédula Profesional", 
          "CURP",
          "Credencial de elector o identificación oficial",
          "Currículum vitae (10 páginas máximo, con correo electrónico y teléfonos de contacto)",
          "Evidencias de su práctica académica o profesional (máximo 30 páginas integradas en un archivo PDF)",
          "Carta de exposición de motivos"
        ]
        break;
      case "AES":
        leyend = "de estudiantes";
        this.convocatoria = "/files/documents/convocatorias/ConvocatoriaAspirantesEstudiantes.pdf";
        this.manual = "/files/documents/convocatorias/ManualAspirantesEstudiantes.pdf";
        this.title = "Aviso estudiante";
        this.aviso = "/files/documents/convocatorias/AvisoEstudiantes.pdf";
        this.requisitos =  [
          "Acta de nacimiento",
          "CURP",
          "Identificación oficial",
          "Certificado de estudios o constancia de estudios",
          "Carta de intención",
          "Comprobante de domicilio",
          "Fotografía tamaño pasaporte (fondo blanco, de frente, reciente, 45 mm x 35mm)",
        ]
        break;
      case "ASE":
        leyend = "de nuevas sedes";
        this.convocatoria = "/files/documents/empty.pdf";
        this.manual = "/files/documents/empty.pdf";
        this.title = "Aviso sedes";
        this.aviso = "/files/documents/empty.pdf";
        this.requisitos =  [
           
        ]
        break;
      default:
        this.$router.push({ path: "/", replace: true });
        break
    }

    this.legend = `Procedimiento para la selección ${leyend} para las Universidades para el Bienestar`
  },
  methods: {
    viewDocument(url) {
      window.open(url, "_blank");
    },
    redirect(slug) {
      this.$router.push({
        path: slug,
        query: {
          rolUsuario: this.type_call,
        },
      });
    },
    convertDate(value) {
      let fecha = new Date(
        (value + " 12:00:00.999").replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
      );
      let options = { month: "long", day: "numeric" };
      return fecha.toLocaleDateString("es-ES", options);
    },
    async getDetail(_id) {
      this.loading = true;
      this.calls = [];
      let dateNow = new Date().toLocaleDateString("en-CA");
      calls
        .getCall(_id)
        .then((resp) => {
          let filterResp = resp.sort(function (a, b) {
            return a.id_convocatoria - b.id_convocatoria;
          });

          const { inicio, fin, status, fecha_publicacion_resultados } =
            filterResp[filterResp.length - 1];

          if (dateNow === fecha_publicacion_resultados) {
            this.viewResp = true;
          } else if (fecha_publicacion_resultados < dateNow) {
            this.viewResp = true;
          }

          this.call = {
            inicio: this.convertDate(inicio),
            fin: this.convertDate(fin),
            status: dateNow >= inicio && dateNow <= fin ? status : "invalida",
            fecha_publicacion_resultados,
            ver_resultado:
              dateNow === fecha_publicacion_resultados
                ? true
                : fecha_publicacion_resultados > dateNow
                  ? true
                  : false,
            convocatoria: this.convocatoria,
            manual: this.manual,
          };

        })
        .catch(() => {
        });
    },
    prepareRegister() {
      this.visiblePDF = true;
    }
  },
  components: {
    Menubar, PdfView
  },
  data() {
    return {
      title:"",
      legend: "",
      visible: false,
      visiblePDF: false,
      convocatoria: "",
      manual: "",
      notas: "",
      call: null,
      aviso:"",
      sections: [
        {
          tipo: "normal",
          doc: "convocatoria",
          desc: (this.type_call == "ASE") ? "Convocatoria para nuevas sedes"
            : (this.type_call == "AES") ? "Convocatoria para aspirantes a estudiantes"
              : (this.type_call == "ADO") && "Convocatoria para aspirantes a docentes",
        },
        {
          tipo: "normal",
          doc: "manual",
          desc: "Manual de usuario",
        },
        {
          tipo: "calendar",
          desc: "Fecha de apertura de la Convocatoria:",
        },
        {
          tipo: "inlineMsg",
          desc: "Antes de realizar tu registro como aspirante a estudiante del Programa, debes consultar el Reglamento Escolar y el Estatuto Académico en la plataforma del Programa. Todos/as los/las estudiantes inscritos/as en el Programa, se comprometerán a cumplir con su normatividad",
        },
        {
          tipo: "listNotes",
          desc: "Lista de requisitos a presentar en su registro",
        },
        // { tipo: "noAction", desc: "Publicación de resultados (1 de julio)" },
      ],
      list_notes: [
        "Revisa con cuidado que la carrera que se imparte y la sede corresponden con tus intereses y posibilidades antes de concluir tu registro.",

        "En caso de que, en el momento de tu registro en la plataforma, no cuentes con el original de certificado de bachillerato, podrás ingresar una constancia de conclusión de tus estudios y presentar el certificado al momento de la inscripción.",

        "Recuerda que, para formalizar tu inscripción, el único lugar autorizado por la Coordinación General del Programa para la recepción de documentos es el plantel de tu elección.",

        "Anota y guarda el número de folio que se genera a la hora de tu registro.",

        "Todos tus datos deben ser auténticos para facilitar tu registro para la beca.",

        "Cuida que tu correo electrónico sea personal, sencillo, lo recuerdes con facilidad y no olvides tu contraseña. De esta forma podrás recibir las notificaciones a tiempo(Evita usar guion bajo en el correo electrónico que emplees para tu registro).",

        "El correo electrónico con el que te registres no podrá ser cambiado",

        "Cada aspirante cuenta con 72 horas para concluir el registro para ser considerado como aspirante a ingresar a una de las sedes del Programa",
      ],
      requisitos: [
        "Acta de nacimiento",
        "CURP",
        "Identificación oficial",
        "Certificado de estudios o constancia de estudios",
        "Carta de intención",
        "Comprobante de domicilio",
        "Fotografía tamaño pasaporte (fondo blanco, de frente, reciente, 45 mm x 35mm)",
      ],
    };
  },
};
</script>
<style>
legend {
  text-align: center;
  margin: 0;
  width: 90% !important;
  margin-left: 20px;
  font-size: 1rem;
  border: 1px solid gray !important;
}

/* icons */

.danger-icon {
  color: rgb(232, 7, 7);
  font-size: 2rem;
}

.success-icon {
  color: rgb(55, 131, 96);
  font-size: 2rem;
}

.secondary-icon {
  color: rgb(64, 65, 65);
  font-size: 2rem;
}
</style>
